import React from 'react';
import Button, { Themes } from 'ui/Button/Button';

import styles from './ApproveReject.module.css';

import cross from 'assets/icons/fail.png';
import check from 'assets/icons/check.png';

interface IApproveSection {
  onClickApprove: () => void;
  onClickReject: () => void;
}

const ApproveSection = ({ onClickApprove, onClickReject }: IApproveSection) => (
  <div className={styles.container}>
    <Button theme={Themes.secondary} type="button" className={styles.btn} onClick={onClickApprove}>
      <div className={styles.btnIconWrapper}>
        <img src={check} alt="approve_icon" />
      </div>
      Approve
    </Button>
    <Button theme={Themes.secondary} type="button" className={styles.btn} onClick={onClickReject}>
      <div className={styles.btnIconWrapper}>
        <img src={cross} alt="reject_icon" />
      </div>
      Reject
    </Button>
  </div>
);

export default ApproveSection;
